<template>
  <div class="mt-3 gpt-text-info quote-carousel" :class="design">
    <span class="gpt-text-message">
      {{ message }}
      <strong class="quote-text-author">~ {{ authorName }}</strong>
    </span>
  </div>
</template>

<script>
import { getRandomQuote } from '@/quote/get-quote.js';

export default {
  data() {
    return {
      message: null,
      authorName: null,
      interval: null,
      design: 'animate',
    };
  },
  methods: {
    carouselData() {
      let index = 0;
      const randomQuoteArray = getRandomQuote();
      const rotateValues = () => {
        this.design = '';
        if (randomQuoteArray.length > 0) {
        const quote = randomQuoteArray[index];
        this.message = quote.quote;
        this.authorName = quote.author;
        index = (index + 1) % randomQuoteArray.length;
        setTimeout(() => {
          this.design = 'animate';
        }, 100);
      }
      };
      rotateValues();
      this.interval = setInterval(rotateValues, 5000);
    },
  },
  created() {
    this.carouselData();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.quote-carousel{
    opacity: 0;
}
.quote-carousel span {
    font-style: italic;
    font-size: 16px;
    background: #e0fbff;
    width: 100%;
    display: block;
    margin: 10px auto 0px !important;
    border-radius: 5px;
    max-width: 600px;
    padding: 20px;
    position: relative;
}
.gpt-text-message{
  color: #0f0f0f;
}

.darkmode .quote-carousel span {
    background: #f2f3f314;
}
.darkmode .gpt-text-message{
  color: #fff;
}
.darkmode .quote-text-author{
  color: #ffffffd1;
}

.quote-carousel span::before {
    content: "";
    position: absolute;
    background-image: url('https://cdn-icons-png.flaticon.com/128/7350/7350737.png');
    top: -15px;
    left: 9px;
    width: 34px;
    height: 34px;
    background-size: contain;
}
.darkmode .quote-carousel span::before {
    background-image: url('../../public/imgs/quote.png');
}
.quote-carousel span strong {
    display: block;
    width: 100%;
    margin-top: 20px;
    text-align: right;
    font-style: normal;
}
.animate {
    animation-name: fade;
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
}
@keyframes fade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

</style>
